import { tagService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    filterInitialized: false,
    loading: true,
    saving: false,
    items: [],
    filter: {},
    meta: {}
  }
}

const actions = {
  getAll ({ commit }) {
    commit('getAllRequest')
    return tagService.getAll()
      .then(
        data => {
          commit('getAllSuccess', data.result)
          return data.result
        }
      )
  },

  getById ({ commit }, id) {
    return tagService.getById(id)
  },

  create ({ commit, dispatch }, tag) {
    commit('startSave')
    return tagService.create(tag)
      .then(tag => {
        commit('endSave')
        commit('createSuccess', tag)
        dispatch('getAll')
        return tag.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, tag) {
    commit('startSave')
    return tagService.update(tag)
      .then(tag => {
        commit('endSave')
        commit('updateSuccess', tag.result)
        return tag.result
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit, dispatch }, id) {
    commit('startSave')

    commit('deleteRequest', id)

    tagService.delete(id)
      .then(tag => {
        commit('endSave')
        commit('deleteSuccess', id)
        dispatch('getAll')
      })
  }
}

const mutations = {
  startSave (state) {
    state.all.saving = true
  },
  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  // Get all
  getAllRequest (state) {
    state.all.loading = true
  },
  getAllSuccess (state, data) {
    state.all.items = data
    state.all.meta = data.meta
    state.all.loading = false
  },
  getAllFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  // Create
  createSuccess (state, updatedTag) {
    Vue.prototype.$toast('Tagg skapad', 'success')
  },
  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa den nya taggen', 'error')
  },

  // Update
  updateSuccess (state, updatedTag) {
    state.all.items = state.all.items.map(tag =>
      tag.TagId === updatedTag.tagId ? updatedTag : tag
    )

    Vue.prototype.$toast('Tagg uppdaterad', 'success')
  },
  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera taggen', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to tag being deleted
    state.all.items = state.all.items.map(tag =>
      tag.tagId === id
        ? { ...tag, deleting: true }
        : tag
    )
  },
  deleteSuccess (state, id) {
    // remove deleted tag from state
    state.all.items = state.all.items.filter(tag => tag.tagId !== id)
  }
}

export const tags = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/tag.module.js